import { formatDate } from './newsroom.js';

export const FAQ_QUESTIONS = 5;
export const MAX_ANSWER_WORDS = 130;

export const countWords = (text) =>
    (text || '').trim().split(/\s+/).filter(Boolean).length;

// The firm's name, or the site's own name when the profile has none to link.
export const websiteLabel = (firm, website) => {
    if (firm) return firm;
    try {
        return new URL(website).hostname.replace(/^www\./, '');
    } catch {
        return null;
    }
};

// Always five inputs in the Storify form; blanks are dropped by the API.
export const faqQuestionInputs = (questions) =>
    Array.from({ length: FAQ_QUESTIONS }, (_, i) => questions?.[i] ?? '');

// The API refuses an offer with nothing to answer; caught before the save.
export const faqIncomplete = ({ faqOffer, faqHeading, faqQuestions }) =>
    Boolean(faqOffer) &&
    (!faqHeading.trim() || !faqQuestions.some((q) => q.trim()));

const STATUS_TEXT = {
    awaiting_answers: 'Paid, waiting for the sponsor’s answers',
    in_review: 'Answers in review',
    live: 'Expert answers live',
    declined: 'Declined',
    expired: 'Expired',
};

// For the Storify panel: where the story's sponsorship is, if anyone has paid.
export const faqSponsorStatusLabel = (story) => {
    const text = STATUS_TEXT[story?.faqSponsorStatus];
    if (!text) return null;
    const running = ['awaiting_answers', 'in_review', 'live'].includes(
        story.faqSponsorStatus
    );
    const until =
        running && story.faqSponsorExpiresAt
            ? ` · runs until ${formatDate(story.faqSponsorExpiresAt)}`
            : '';
    return `${text}${until}`;
};

// What the pay page says when the API turns a responder away.
export const sponsorCheckoutError = (response, renewing = false) => {
    if (response?.data?.code === 'ALREADY_SPONSOR') return 'yours';
    if (renewing && response?.status === 404) return 'nothingToRenew';
    if (response?.status === 409) return 'taken';
    if (response?.status === 403) return 'notResponder';
    if (response?.status === 404) return 'notOffered';
    return 'failed';
};
